import React from "react";

interface DescriptionProps {
  children: React.ReactNode;
}

export const Description: React.FC<DescriptionProps> = ({ children }) => {
  return (
    <p className="mb-3 min-h-[14px] text-[12px] font-[400px] text-gray-600 md:text-[16px] lg:text-[14px] lg:min-h-[20px]">
      {children}
    </p>
  );
};
